import Identificacion from "../Comun/Identificacion";
import TipoAutorizacion from "./TipoAutorizacion";

export default class ParametroConsultaPersona {

    constructor() {
        this.Identificacion = new Identificacion();
        this.TipoAutorizacion = new TipoAutorizacion();
    }
    Identificacion: Identificacion
    TipoAutorizacion: TipoAutorizacion;

}